import { render, staticRenderFns } from "./ReferencePopup.vue?vue&type=template&id=78ab1f9d"
import script from "./ReferencePopup.vue?vue&type=script&lang=js"
export * from "./ReferencePopup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports